module.exports = __webpack_public_path__ + "static/media/centralised-timesheets.4b1654f4.png";